(() => {
  if (document.getElementById('koppa-back-to-top')) return;
  const mobile = matchMedia('(max-width: 767px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const button = document.createElement('button');
  button.id = 'koppa-back-to-top'; button.type = 'button'; button.hidden = true;
  button.setAttribute('aria-label', 'Back to top');
  button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5m-6 6 6-6 6 6"/></svg>';
  document.body.append(button);
  const visible = element => { const box=element.getBoundingClientRect(); const style=getComputedStyle(element); return box.width>0 && box.height>0 && box.bottom>0 && box.top<innerHeight && box.right>0 && box.left<innerWidth && style.visibility!=='hidden' && style.display!=='none' && Number(style.opacity)>0 && !element.closest('[aria-hidden="true"]'); };
  let scheduled = false;
  let scrolled = scrollY >= 600;
  const overlaySelector = 'dialog,cart-drawer,#Details-menu-drawer-container,.menu-drawer,#csp-overlay,[aria-modal],.koppa-mobile-action,.protocol-mobile-action,.kp-mobile-purchase,#shopify-pc__banner';
  const update = () => {
    scheduled = false;
    if (!mobile.matches || !scrolled) {
      if (!button.hidden) button.hidden = true;
      return;
    }
    const modal = [...document.querySelectorAll('dialog[open],cart-drawer.active,.menu-opening,#csp-overlay,[aria-modal="true"]')].some(visible);
    const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
    if (modal || typing) {
      if (!button.hidden) button.hidden = true;
      return;
    }
    let bottom = 16;
    document.querySelectorAll('.koppa-mobile-action:not([hidden]),.protocol-mobile-action:not([hidden]),.kp-mobile-purchase:not([hidden]),#shopify-pc__banner').forEach(element => {
      if (!visible(element)) return;
      const box = element.getBoundingClientRect();
      if (getComputedStyle(element).position === 'fixed' && box.bottom >= innerHeight - 8 && box.top > innerHeight / 2) bottom = Math.max(bottom, innerHeight - box.top + 12);
    });
    const offset = `${bottom}px`;
    if (button.style.getPropertyValue('--koppa-top-bottom') !== offset) button.style.setProperty('--koppa-top-bottom', offset);
    if (button.hidden) button.hidden = false;
  };
  const schedule = () => { if (!scheduled) { scheduled=true; requestAnimationFrame(update); } };
  button.addEventListener('click', () => {
    const top = document.querySelector('#MainContent h1, #MainContent [aria-level="1"], #MainContent');
    if (top) { const previous=top.getAttribute('tabindex'); top.setAttribute('tabindex','-1'); top.focus({preventScroll:true}); top.addEventListener('blur',()=>{if(previous===null)top.removeAttribute('tabindex');else top.setAttribute('tabindex',previous);},{once:true}); }
    window.scrollTo({top:0,behavior:reduced.matches?'instant':'smooth'});
  });
  const onScroll = () => { scrolled = scrollY >= 600; schedule(); };
  addEventListener('scroll',onScroll,{passive:true}); addEventListener('resize',schedule,{passive:true});
  addEventListener('pageshow',onScroll);
  window.visualViewport?.addEventListener('resize',schedule,{passive:true});
  const stickyBars = document.querySelectorAll('.koppa-mobile-action,.protocol-mobile-action,.kp-mobile-purchase,#shopify-pc__banner');
  if (typeof ResizeObserver !== 'undefined') {
    const resizeObserver = new ResizeObserver(schedule);
    stickyBars.forEach(element => resizeObserver.observe(element));
  }
  document.addEventListener('focusin',schedule); document.addEventListener('focusout',schedule); mobile.addEventListener('change',schedule);
  new MutationObserver(records=>{if(mobile.matches && scrolled && records.some(record=>record.target!==button && (record.target.matches(overlaySelector) || record.target.querySelector(overlaySelector))))schedule();}).observe(document.body,{subtree:true,attributes:true,attributeFilter:['class','open','hidden','style','aria-modal']});
  update();
})();

